import { Task } from "../interfaces/TaskTypes";
import { db } from "./firebase";

import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
  updateDoc,
  doc,
  deleteDoc,
} from "firebase/firestore";

const editTask = async (id: string, data: Task) => {
  const q = query(collection(db, `tasks`), where("id", "==", id));

  const querySnapshot = await getDocs(q);
  const document = doc(db, "tasks", querySnapshot.docs[0].id);

  await updateDoc(document, { ...data });
};

const deleteTask = async (id: string) => {
  const q = query(collection(db, `tasks`), where("id", "==", id));

  const querySnapshot = await getDocs(q);
  const document = doc(db, "tasks", querySnapshot.docs[0].id);

  await deleteDoc(document);
};

export { editTask, deleteTask };
